export const appId = 'org.openedx.frontend.app.authn';

// Route roles
export const loginRole = 'org.openedx.frontend.role.login';
export const registerRole = 'org.openedx.frontend.role.register';
export const resetPasswordRole = 'org.openedx.frontend.role.resetPassword';
export const confirmPasswordRole = 'org.openedx.frontend.role.confirmPassword';
export const welcomeRole = 'org.openedx.frontend.role.welcome';
export const dashboardRole = 'org.openedx.frontend.role.dashboard';

// Route path segments
export const loginPath = 'login';
export const registerPath = 'register';
export const registerEmbeddedPath = 'register-embedded';
export const resetPath = 'reset';
export const welcomePath = 'welcome';
export const passwordResetConfirmPath = 'password_reset_confirm';
export const notFoundPath = 'notfound';
